/* eslint-disable */
import {
  Payments_Definitions_Payments_BankAccountTypeEnumInput as BankAccountTypeEnumInput,
  Payments_Definitions_Payments_BankAccountTypeInput as BankAccountTypeInput,
  Payments_Definitions_Payments_CardTypeInput as CardTypeInput,
} from 'components/Core/WalletForms/queries/transformed/lib/schema';

export { BankAccountTypeEnumInput };

export enum ParentTypeEnum {
  CUSTOMERS = 'customers',
  USERS = 'users',
  VENDORS = 'vendors',
}

interface IUSBankAccountCreateData extends BankAccountTypeInput {
  bankCode: string;
  accountType: BankAccountTypeEnumInput;
  accountNumber: string;
  name: string;
  savePaymentMethod?: boolean;
  accountNumberConfirm: string;
}

interface ICABankAccountCreateData extends BankAccountTypeInput {
  accountType: BankAccountTypeEnumInput;
  accountNumber: string;
  name: string;
  savePaymentMethod?: boolean;
  transitNumber: string;
  institutionNumber: string;
  zipCode: string;
  padTerms: string;
}

export type IBankAccountCreateData = ICABankAccountCreateData | IUSBankAccountCreateData
export interface ICardCreateData extends CardTypeInput {
  number: string;
  cvc: string;
  name: string;
  savePaymentMethod?: boolean;
}

export type IBankAccountUpdateData = Pick<
  BankAccountTypeInput,
  Exclude<keyof BankAccountTypeInput, 'bankCode' | 'accountNumber'>
>;

export type ICardUpdateData = Pick<
  CardTypeInput,
  Exclude<keyof CardTypeInput, 'number' | 'cvc' | 'cardType'>
>;
